export default {"src":"/_next/static/media/ico1.69df0d05.svg","height":65,"width":67,"blurWidth":0,"blurHeight":0};